export function getCookie(cname:string) {
  const name = cname + '=';
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}


export function getStockOnHand(current:any, max:any, eta:any, freight:any, sohType:any) {
  if (sohType == null || sohType == '' || sohType.Length <= 0) {
    if (current.Length > 8) {
      return " ";
    }
    else if (max == "0" && eta != null && eta != '' && freight == "N") {
      return eta;
    }
    else {
      //If the Max quantity is less than the available quantity show the max quantity with a "+" on the end, else show the available quantity
      if (Number.parseInt(max) < Number.parseInt(current) && max != 0) {
        return max + "+";
      }
      else {
        return current;
      }
    }
  }
  else {
    return freight;
  }

}

export function isNullOrUndefined(value: any) {
  return value === null || value === undefined;
}